"use strict";

import "babel-polyfill";
import coreFactory from "./common/core";
import sandboxFactory from "./common/sandbox";

// Modules
import monthlyPeriodSelectsFactory from "./viewing-summary/monthly-period-selects";
import monthlySummaryReport from "./viewing-summary/monthly-viewing-summary-report";
import moreInfo from "./top-programmes/more-info";

const core = coreFactory(window.jQuery, sandboxFactory);

core.createModule(
    "period_selects",
    monthlyPeriodSelectsFactory("viewing-report/four-s-svod-half-percent-monthly/filters")
);
core.createModule(
    "monthly_viewing_summary",
    monthlySummaryReport("viewing-report/four-s-svod-monthly-half-percent/data")
);
core.createModule("moreInfo", moreInfo);

core.startAll();
